export default __webpack_public_path__ + "images/check-white-icon.svg?f0ed6f45a2449a7578fee6a8ca02ddc3";